"use strict";
/**
 * Canonical onboarding questionnaire ("Brand Status Quo & Objective").
 *
 * Owned here so the backend tool and the frontend wizard render the exact same
 * fixed question set. The agent never authors these questions; it only opens the
 * survey and, once answered, writes an LLM report into the BRAND_STATUS_QUO file.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BRAND_STATUS_QUO_QUESTIONS = exports.BRAND_STATUS_QUO_MODE_ID = exports.BRAND_STATUS_QUO_FILE_TITLE = void 0;
exports.BRAND_STATUS_QUO_FILE_TITLE = 'Brand Status Quo & Objective';
exports.BRAND_STATUS_QUO_MODE_ID = 'brand-status-quo';
exports.BRAND_STATUS_QUO_QUESTIONS = [
    {
        id: 'role',
        title: "Who's filling this in?",
        select: 'single',
        allowOther: true,
        options: [
            { id: 'founder', label: 'Founder / CEO / Brand Owner' },
            { id: 'marketer', label: 'In-house Marketer / Growth Lead' },
            { id: 'agency', label: 'Agency / Consultant / Freelance' },
            { id: 'investor', label: 'Investor / Operator' },
        ],
    },
    {
        id: 'channels',
        title: 'Where are you advertising today?',
        subtitle: 'Select all that apply',
        select: 'multi',
        allowOther: true,
        otherLabel: 'Add your own answer...',
        options: [
            { id: 'meta', label: 'Meta (Facebook / Instagram)' },
            { id: 'google', label: 'Google' },
            { id: 'tiktok', label: 'TikTok' },
            { id: 'linkedin', label: 'LinkedIn' },
            { id: 'none', label: 'Not running paid ads yet' },
        ],
    },
    {
        id: 'spend',
        title: 'What did you spend in the last 30 days?',
        select: 'single',
        options: [
            { id: 's0', label: '$0 / just getting started' },
            { id: 's1_10', label: '$1K–$10K' },
            { id: 's11_30', label: '$11K–$30K' },
            { id: 's31_100', label: '$31K–$100K' },
            { id: 's100p', label: '$100K+' },
        ],
    },
    {
        id: 'account_mgmt',
        title: 'Who manages your ad accounts day to day?',
        select: 'single',
        showIf: { questionId: 'spend', optionIds: ['s31_100', 's100p'] },
        options: [
            { id: 'inhouse', label: 'In-house' },
            { id: 'freelancer', label: 'Freelancer' },
            { id: 'agency', label: 'Agency' },
        ],
    },
    {
        id: 'goal',
        title: "What's your main goal right now?",
        subtitle: 'Select all that apply',
        select: 'multi',
        allowOther: true,
        options: [
            { id: 'concepts', label: 'More winning creative concepts', caption: 'Ad fatigue is killing performance' },
            { id: 'volume', label: 'Keep up with creative volume', caption: "We can't produce enough at our scale" },
            { id: 'stop_losing', label: 'Stop losing money on ads', caption: 'We need to try something different' },
            { id: 'roas', label: 'Hit our target ROAS', caption: "Profitable, but conversion isn't there yet" },
            { id: 'cac', label: 'Bring down CAC', caption: 'We need better cost efficiency' },
            { id: 'ceiling', label: 'Find the ceiling', caption: 'Doing well and want to scale further' },
            { id: 'starting', label: 'Just starting with paid ads', caption: "It's overwhelming" },
        ],
    },
    {
        id: 'timeline',
        title: 'When do you want your first ads live?',
        select: 'single',
        options: [
            { id: 'asap', label: 'ASAP / this week' },
            { id: 'month', label: 'Within a month' },
            { id: 'planning', label: 'Still planning — no deadline yet' },
        ],
    },
];
